module.exports = __webpack_public_path__ + "img/edit_icon_1.68abe807.svg";